import { Configuration } from "../configuration.model";

export class UserSessionDetails {
    constructor() {
        this.authenticationStatus = 'UNAUTHORIZED';
        this.bearerToken = '';
        this.userId = '';
        this.configuration = new Configuration();
    }

    authenticationStatus: string;
    bearerToken: string;
    userId: string;
    configuration: Configuration;

    // Values used for guid login via url
    linkGuidTenant?: string;
    linkGuid?: string;
    linkGuidLoginError?: string;
}
